module.exports = __webpack_public_path__ + "img/11_92.44227b03.png";